
import {UIGamePopupController} from '../../../../shared/scripts/ui_game/ui_game_popup/UIGamePopupController'
import {UIWGamePopupCardConfirmation} from './UIWGamePopupCardConfirmation'
import {UIWGamePopupSelectPlayerAndResourceCard} from './UIWGamePopupSelectPlayerAndResourceCard'
import {CardPopupInformation,
    SelectCardPopupUsingDevelopmentCardFormat, SelectCardPopupForPendingDistributionFormat, SelectCardPopupStealCardFromAnotherPlayerFormat,
    SelectCardToDiscardFormat, SelectCardsToGiveToAnotherPlayer, SelectPlayerAndResourceCardFormat,
} from '@colonist/game-card-types'
import {UIGamePopupCardConfirmation} from '../../../../shared/scripts/ui_game/ui_game_popup/UIGamePopupCardConfirmation'
import {UIGamePopupInformationView} from '../../../../shared/scripts/ui_game/ui_game_popup/UIGamePopupInformationView'
import {UIGamePopupSelectCards} from '../../../../shared/scripts/ui_game/ui_game_popup/UIGamePopupSelectCards'
import {UIGamePopupSelectDevelopmentCardFromPlayer} from '../../../../shared/scripts/ui_game/ui_game_popup/UIGamePopupSelectDevelopmentCardFromPlayer'
import {UIGamePopupSelectResourcesCardsFromPlayer} from '../../../../shared/scripts/ui_game/ui_game_popup/UIGamePopupSelectResourcesCardsFromPlayer'
import {UIGamePopupSelectPlayerAndResourceCard} from '../../../../shared/scripts/ui_game/ui_game_popup/UIGamePopupSelectPlayerAndResourceCard'
import {UIGamePopupSelectDice} from '../../../../shared/scripts/ui_game/ui_game_popup/UIGamePopupSelectDice'
import {UIWGamePopupSelectCardToGiveToAnotherPlayer} from './UIWGamePopupSelectCardToGiveToAnotherPlayer'
import {UIWGamePopupDiscardCards} from './UIWGamePopupDiscardCards'
import {SelectDiceFormat, PopupInformation} from '@colonist/game-base-types'
import {UIGamePopupMechanicIntroductionForBeginners} from '../../../../shared/scripts/ui_game/ui_game_popup/UIGamePopupMechanicIntroductionForBeginners'

export class UIWGamePopupController extends UIGamePopupController {
    protected createPopupCardConfirmationView(cardPopupInformationFormat: CardPopupInformation): UIGamePopupCardConfirmation {
        return new UIWGamePopupCardConfirmation(this.uiGameManager, cardPopupInformationFormat)
    }

    protected createPopupSelectPlayerAndResourceCard(popupImageAndDescription: UIGamePopupInformationView, selectionFormat: SelectPlayerAndResourceCardFormat): UIGamePopupSelectPlayerAndResourceCard {
        return new UIWGamePopupSelectPlayerAndResourceCard(this.uiGameManager, popupImageAndDescription, selectionFormat)
    }

    getViewForCardConfirmationPopup(cardPopupInformationFormat: CardPopupInformation) {
        return new UIWGamePopupCardConfirmation(this.uiGameManager, cardPopupInformationFormat)
    }

    getPopupImageAndDescriptionForCardSelectorWindowForDevelopmentCard(popupInformation: PopupInformation) {
        return new UIGamePopupInformationView(this.uiGameManager, 0, 0, this.popupW, popupInformation)
    }

    getViewForCardSelectorWindowForDevelopmentCard(developmentCardSelectFormat: SelectCardPopupUsingDevelopmentCardFormat, popupImageAndDescription: UIGamePopupInformationView) {
        return new UIGamePopupSelectCards(this.uiGameManager, popupImageAndDescription, developmentCardSelectFormat.selectCardFormat)
    }

    getPopupImageAndDescriptionForCardSelectorWindowForPendingDistributions(popupInformation: PopupInformation) {
        return new UIGamePopupInformationView(this.uiGameManager, 0, 0, this.popupW, popupInformation)
    }

    getViewForCardSelectorWindowForPendingDistributions(pendingDistributionSelectFormat: SelectCardPopupForPendingDistributionFormat, popupImageAndDescription: UIGamePopupInformationView) {
        return new UIGamePopupSelectCards(this.uiGameManager, popupImageAndDescription, pendingDistributionSelectFormat.selectCardFormat)
    }

    getPopupImageAndDescriptionForCardSelectorWindowForGivingCardToAnotherPlayer(popupInformation: PopupInformation) {
        return new UIGamePopupInformationView(this.uiGameManager, 0, 0, this.popupW, popupInformation)
    }

    getViewForCardSelectorWindowForGivingCardToAnotherPlayer(selectCardFormat: SelectCardsToGiveToAnotherPlayer, popupImageAndDescription: UIGamePopupInformationView) {
        return new UIWGamePopupSelectCardToGiveToAnotherPlayer(this.uiGameManager, popupImageAndDescription, selectCardFormat)
    }

    getViewForCardDiscardPopup(discardCardFormat: SelectCardToDiscardFormat) {
        return new UIWGamePopupDiscardCards(this.uiGameManager, discardCardFormat, this.progressCardsState)
    }

    getPopupImageAndDescriptionForCardSelectorWindowToStealDevelopmentCard(popupInformation: PopupInformation) {
        return new UIGamePopupInformationView(this.uiGameManager, 0, 0, this.popupW, popupInformation)
    }

    getViewForCardSelectorWindowToStealDevelopmentCard(stealDevelopmentCardFormat: SelectCardPopupStealCardFromAnotherPlayerFormat, popupImageAndDescription: UIGamePopupInformationView) {
        return new UIGamePopupSelectDevelopmentCardFromPlayer(this.uiGameManager, popupImageAndDescription, stealDevelopmentCardFormat)
    }

    getPopupImageAndDescriptionForCardSelectorWindowToStealResourceCard(stealResourceCardFromAnotherPlayer: SelectCardPopupStealCardFromAnotherPlayerFormat, popupInformation: PopupInformation) {
        return new UIGamePopupInformationView(this.uiGameManager, 0, 0, this.popupW, popupInformation, undefined, stealResourceCardFromAnotherPlayer.overrideText)
    }

    getViewForCardSelectorWindowToStealResourceCard(stealResourceCardFromAnotherPlayer: SelectCardPopupStealCardFromAnotherPlayerFormat, popupImageAndDescription: UIGamePopupInformationView) {
        return new UIGamePopupSelectResourcesCardsFromPlayer(this.uiGameManager, popupImageAndDescription, stealResourceCardFromAnotherPlayer)
    }

    getPopupImageAndDescriptionForSelectPlayerUsingDevelopmentCard(popupInformation: PopupInformation) {
        return new UIGamePopupInformationView(this.uiGameManager, 0, 0, this.popupW, popupInformation)
    }

    getPopupImageAndDescriptionForSelectPlayerAndResourceCard(popupInformation: PopupInformation) {
        return new UIGamePopupInformationView(this.uiGameManager, 0, 0, this.popupW, popupInformation)
    }

    getViewForSelectPlayerAndResourceCard(selectionFormat: SelectPlayerAndResourceCardFormat, popupImageAndDescription: UIGamePopupInformationView) {
        return new UIWGamePopupSelectPlayerAndResourceCard(this.uiGameManager, popupImageAndDescription, selectionFormat)
    }

    protected getViewForMechanicIntroductionForBeginners(popupImageAndDescription: PopupInformation): UIGamePopupMechanicIntroductionForBeginners {
        return new UIGamePopupMechanicIntroductionForBeginners(this.uiGameManager, popupImageAndDescription)
    }

    getPopupImageAndDescriptionForSelectDice(popupInformation: PopupInformation) {
        return new UIGamePopupInformationView(this.uiGameManager, 0, 0, this.popupW, popupInformation)
    }

    getViewForSelectDice(selectDiceFormat: SelectDiceFormat, popupImageAndDescription: UIGamePopupInformationView) {
        return new UIGamePopupSelectDice(this.uiGameManager, popupImageAndDescription, selectDiceFormat)
    }
}
